import { PRODUCT_KEYS, CONFIG_PRODUCTS } from '@/legacy/components/Products/constants'
import type { Category } from '@/legacy/models'

type BreadcrumbItem = {
  label: string
  href?: string
}

export function generateBreadcrumb(
  category: Category,
  arr: BreadcrumbItem[] = [],
  options: { noHref?: boolean } = { noHref: false },
): BreadcrumbItem[] {
  const parent = category.parent.value?.data
  const href = ['/blog']

  if (category.product && category.product !== PRODUCT_KEYS.serasa) {
    href.unshift(CONFIG_PRODUCTS[category.product as keyof typeof CONFIG_PRODUCTS].url)
  }

  if (parent && category.product !== PRODUCT_KEYS.serasa) {
    href.push(`/${category.slug}`)
  }

  const bread = {
    label: category.name,
    ...(!options.noHref && { href: href.join('').replace('//', '') }),
  }

  if (parent) {
    return generateBreadcrumb(parent, [bread, ...arr], options)
  }

  return [bread, ...arr]
}
